module.exports = __webpack_public_path__ + "img/leaf.1e1b13f0.png";